import { render, staticRenderFns } from "./BenutzerSuche.vue?vue&type=template&id=2749a39a"
import script from "./BenutzerSuche.vue?vue&type=script&lang=js"
export * from "./BenutzerSuche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports